import { TranslationKey } from '@/modules'

export const getDifficultyBadgeColor = (difficulty: string): string => {
  const difficultyColors = {
    'Easy': 'bg-success/10 text-success border border-success/20',
    'Intermediate': 'bg-accent/10 text-accent border border-accent/20',
    'Hard': 'bg-warning/10 text-warning border border-warning/20',
    'Expert': 'bg-error/10 text-error border border-error/20',
  }
  return difficultyColors[difficulty as keyof typeof difficultyColors] || 'bg-muted/10 text-muted border border-muted/20'
}

export interface Column {
  key: keyof import('@duck/api-definitions').TaskService.Task
  label: TranslationKey
  sortable: boolean
  visible: boolean
}

export const baseColumns: Column[] = [
  { key: 'name', label: 'common.name', sortable: true, visible: true },
  { key: 'teaser', label: 'common.teaser', sortable: true, visible: true },
  { key: 'body', label: 'common.body', sortable: false, visible: false },
  { key: 'difficulty', label: 'common.difficulty', sortable: true, visible: true },
  { key: 'description', label: 'common.description', sortable: false, visible: true },
  { key: 'accessGroups', label: 'common.accessGroups', sortable: false, visible: false },
]

